let listenAction
let stickyTop
let params
let zIndex
let className

export default {
    bind(el, binding) {
        const params = binding.value || {}
        stickyTop = params.stickyTop || 0
        zIndex = params.zIndex || 1000
        className = params.className || 'sticky'

        let a = el, b = null, parentSelector = null // селектор блока, который нужно закрепить

        const sticky = () => {
            b.className = className
            b.style.top = `${stickyTop}px`
            b.style.zIndex = zIndex
            b.style.position = 'fixed'
        }
        const stop = () => {
            b.className = 'stop'
            b.style.position = 'relative'
        }
        const reset = () => {
            b.className = ''
            b.style.top = ''
            b.style.zIndex = ''
            b.style.position = ''
        }

        listenAction = () => {
            parentSelector = params.parent ? document.querySelector(params.parent) : null
            if (b == null) {  // добавить потомка-обёртку, чтобы убрать зависимость с соседями
                var Sa = getComputedStyle(a, ''), s = ''
                for (var i = 0; i < Sa.length; i++) {  // перечислить стили CSS, которые нужно скопировать с родителя
                    if (Sa[i].indexOf('overflow') == 0 || Sa[i].indexOf('padding') == 0 || Sa[i].indexOf('border') == 0 || Sa[i].indexOf('outline') == 0 || Sa[i].indexOf('box-shadow') == 0 || Sa[i].indexOf('background') == 0) {
                        s += Sa[i] + ': ' + Sa.getPropertyValue(Sa[i]) + '; '
                    }
                }
                b = document.createElement('div')  // создать потомка
                b.style.cssText = s + ' box-sizing: border-box; width: ' + a.offsetWidth + 'px;'
                a.insertBefore(b, a.firstChild);  // поместить потомка в цепляющийся блок первым
                var l = a.childNodes.length;
                for (var i = 1; i < l; i++) {  // переместить во вновь созданного потомка всех остальных потомков (итого: создан потомок-обёртка, внутри которого по прежнему работают скрипты)
                    b.appendChild(a.childNodes[1])
                }
                a.style.height = b.getBoundingClientRect().height + 'px'  // если под скользящим элементом есть другие блоки, можно своё значение
                a.style.padding = '0'
                a.style.border = '0'  // если элементу присвоен padding или border
            }
            let Ra = a.getBoundingClientRect()
            if (parentSelector != null) {
                let R = Math.round(Ra.top + b.getBoundingClientRect().height - parentSelector.getBoundingClientRect().bottom)
                if ((Ra.top - stickyTop) <= 0) {
                    if ((Ra.top - stickyTop) <= R) {
                        stop()
                        b.style.top = - R + 'px'
                    } else {
                        sticky()
                    }
                } else {
                    reset()
                }
            } else {
                if (Ra.top <= 0) { // elem.getBoundingClientRect() возвращает в px координаты элемента относительно верхнего левого угла области просмотра окна браузера
                    sticky()
                } else {
                    reset()
                }
            }

            window.addEventListener('resize', () => {
                a.children[0].style.width = getComputedStyle(a, '').width
            }, false)  // если изменить размер окна браузера, измениться ширина элемента
        }

        window.addEventListener('scroll', listenAction, false)
        document.body.addEventListener('scroll', listenAction, false)  // если у html и body высота равна 100%
    },

    unbind() {
        window.removeEventListener('scroll', listenAction)
        document.body.removeEventListener('scroll', listenAction)
    },

    update(el, binding) {
    },
}


// WEBPACK FOOTER //
// ./src/webpack/vue/components/sticky.js